<template>
  <div class="common-box">
    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="70px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="配件编号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.materialNumber"
              placeholder="请输入配件编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="配件名称：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.materialName" placeholder="请输入配件名称"
              clearable></el-input>
          </el-form-item>

          <el-form-item label="货位编号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.shelfNumber" placeholder="请输入货位编号"
              clearable></el-input>
          </el-form-item>

          <el-form-item label="规格：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.specification" placeholder="请输入规格"
              clearable></el-input>
          </el-form-item>

          <el-form-item label="使用单位：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.useUnit" placeholder="请输入使用单位"
              clearable></el-input>
          </el-form-item>

          <el-form-item label="供应商：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.supplier" placeholder="请输入供应商"
              clearable></el-input>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button size="mini" type="primary" class="plr28" @click="handleDelete" plain>删除
        </el-button>
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="materialNumber" label="配件编号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="materialName" label="配件名称" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="costAmount" label="成本价" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="salesAmount" label="售价" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="shelfNumber" label="货位编号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="specification" label="规格" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="amount" label="数量" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="useUnit" label="使用单位" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supplier" label="供应商" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supplier" label="图片" width="200">
            <template slot-scope="scope">
              <ul class="photoBox">
                <li v-for="item in scope.row.imageList">
                  <el-image style="width: 100px; height: 100px" :src="item" :z-index="9999">
                  </el-image>
                </li>
              </ul>
              <el-image></el-image>
            </template>
          </el-table-column>

          <el-table-column show-overflow-tooltip prop="createTime" label="添加时间" width="200">
            <template slot-scope="scope">
              {{scope.row.createTime ? scope.row.createTime.slice(0, 10) : ''}}
            </template>
          </el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini"  type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide" ></div>
              <el-button size="mini" type="text" @click="handleDeleteCause(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <add-cause v-if="addCauseVisible" @cancel="addCauseVisible = false" @confirm="handleAddCauseConfirm"></add-cause>
    <edit-cause v-if="editCauseVisible" :detail="causeDetail" @cancel="editCauseVisible = false"
      @confirm="handleEditCauseConfirm"></edit-cause>
  </div>
</template>

<script>
  import {
    getMaterialInfoList,
    deleteMaterialInfo
  } from '@/api/Material'

  import AddCause from './components/AddCause'
  import EditCause from './components/EditCause'
  export default {
    name: 'MaterialInfo',
    components: {
      AddCause,
      EditCause,
    },
    data() {
      return {
        form: {
          materialNumber: '',
          materialName: '',
          shelfNumber: '',
          specification: '',
          useUnit: '',
          supplier: '',
        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addCauseVisible: false,
        editCauseVisible: false,
        checkDepartment: false,
        causeDetail: {}
      }
    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      }
    },
    created() {
      this.getListData()
    },
    methods: {
      async getListData() {
        this.tableLoading = true
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        const res = await getMaterialInfoList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for (let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleDeleteCause(row) {
        const idList = [row.id]
        this.deleteCause(idList)
      },
      handleCheck(row) {
        this.causeDetail = row
        this.checkDepartment = true
      },
      handleEdit(row) {
        this.causeDetail = row
        this.editCauseVisible = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.id)
        this.deleteMaterialInfo(idList)
      },
      deleteMaterialInfo(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteMaterialInfo({
            idList
          })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleAdd() {
        this.addCauseVisible = true
      },
      exportCause() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportCause(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },
      handleAddCauseConfirm() {
        this.addCauseVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleEditCauseConfirm() {
        this.editCauseVisible = false
        this.getListData()
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaterialManagement/MaterialManagement.vue